module.exports = __webpack_public_path__ + "static/media/SellerboxFuncIconFace.0fabe261.png";